import React from "react";
import "../../containers/bookings/modals/Modal.scss";
import Cancel from "../../assets/images/cancel.svg";
import "./DeletePopup.scss";

class DeletePopup extends React.Component {
  state = { showModal: false };
  /**
   * Handle the popup toggle when click on delete icon from grid
   * @param object - (deleteObj - Required data to perform delete operation)
   */
  handleToogleModal = deleteObj => e => {
    e.preventDefault();
    this.deleteDetails = deleteObj;
    this.setState({ showModal: !this.state.showModal });
  };

  /**
   * Handle the two confirmation box to perform delete operation
   * @param boolean - (confirmStatus)
   */
  handleDeleteConfirmation(confirmStatus, e) {
    e.preventDefault();
    if (confirmStatus) {
      this.props.grid.deleteRecord(this.deleteDetails);
    }
    this.setState({ showModal: false });
  }

  render() {
    const { showModal } = this.state;
    return (
      <div
        className="modal"
        style={{
          display: showModal ? "block" : "none"
        }}
      >
        <div className="modal-dialog">
          <div className="modal-content delete-wid">
            <div className="modal-pad">
              <div className="modal-col modal-con delete-height">
                <div className="modal-row">
                  <div className="modal-header col-12">
                    <h3 className="delete-h">Do you want to delete it?</h3>
                    <span
                      onClick={e => this.handleDeleteConfirmation(false, e)}
                    >
                      <img className="close-btn" src={Cancel} alt="cancel" />
                    </span>
                  </div>
                  <div className="col-12">
                    <div className="nav-flex flex-end">
                      <div className="mx-10">
                        <button
                          className="btn1 cancel-mar blue-focus"
                          type="button"
                          onClick={e => this.handleDeleteConfirmation(false, e)}
                        >
                          Cancel
                        </button>
                      </div>
                      <div className="mx-10">
                        <button
                          className="btn1 btn-mar yellow-focus dark-bg"
                          type="button"
                          onClick={e => this.handleDeleteConfirmation(true, e)}
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DeletePopup;
